import {
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { Box } from '@mui/system';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
// react icons
import { GiPayMoney, GiTakeMyMoney } from 'react-icons/gi';
import { MdOutlineDateRange, MdOutlineMoreHoriz, MdOutlineSendToMobile } from 'react-icons/md';
// material icons
import AdUnitsIcon from '@mui/icons-material/AdUnits';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CloseIcon from '@mui/icons-material/Close';
import EventIcon from '@mui/icons-material/Event';
import EventNoteIcon from '@mui/icons-material/EventNote';
import GroupIcon from '@mui/icons-material/Group';
import CustomDate from '../../components/CustomDate';
import { fDate, fDate2 } from '../../utils/formatTime';
import { NOT_AVAILABLE } from '../Global/Constants';
import Loader from '../Global/Loader';

// componenets
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import ApiErrorMessage from '../Global/ApiErrorMessage';
import RevenueService from '../services/RevenueService';
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import {
  getBankBranchData,
  getBankDropdownData,
  getLoanTypeData,
  getMasterListType,
  saveApiData,
  setBranchDetails
} from '../../store/Slice/Global/GlobalSlice';
import useRevenueSelector from '../../store/Slice/Revenue/RevenueSelector';
import {
  getRevenueCommentLogs,
  getRevenuePartnerDetails,
  getRevenueViewData
} from '../../store/Slice/Revenue/RevenueSlice';
import { isValidValue, normalizeValue } from '../../utils/CommonFunction';
import CustomInput from '../../components/CustomInput';
import CustomSelect from '../../components/CustomSelect';
import { RevenueApi } from '../../utils/Apis';
import { StyledIconButton, StyledTableRow } from '../../utils/StyleTable';
import { setApiError } from '../../store/Slice/Error/ErrorSlice';
import ViewLargeCard from '../../components/ViewLargeCard';
import ViewCardComponent from '../../components/ViewCards';

const { EditPartnerDetail, CheckPartnerExist } = RevenueService;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 12,
    padding: '6px',
    height: '42.5px',
    fontWeight: 500,
    textTransform: 'uppercase',
    color: '#0d4689'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    padding: '4px 6px',
    height: '42.5px'
  }
}));
// const revenueValidationSchema = yup.object().shape({
//   bankId: yup
//     .string()
//     .nullable()
//     .required('Bank Name is required')
//     .notOneOf(['', ' ', null], 'Please select a valid Bank'),

//   branchId: yup
//     .string()
//     .nullable()
//     .required('Branch Name is required')
//     .notOneOf(['', ' ', null], 'Please select a valid Branch'),

//   fileNumber: yup
//     .string()
//     .required('File No is required')
//     .max(50, 'File No must be less than 50 characters'),

//   borrowerName: yup
//     .string()
//     .required('Borrower Name is required')
//     .max(50, 'Borrower Name must be less than 50 characters'),

//   revenueFileTypeId: yup
//     .string()
//     .nullable()
//     .required('File Type is required')
//     .notOneOf(['', ' ', null], 'Please select a valid File Type'),

//   loanAmountRequested: yup
//     .number()
//     .nullable()
//     .transform((value, originalValue) => (String(originalValue).trim() === '' ? null : value))
//     .when('revenueFileTypeId', {
//       is: (val) => Number(val) !== 132, // <-- convert val to number
//       then: (schema) =>
//         schema
//           .required('Loan Amount is required')
//           .positive('Loan Amount must be greater than 0')
//           .max(1000000000, 'Please enter amount less than 10,00,00,000'),
//       otherwise: (schema) => schema.notRequired()
//     }),

//   loanAmountDisbursed: yup
//     .number()
//     .nullable()
//     .transform((value, originalValue) => (String(originalValue).trim() === '' ? null : value))
//     .when('revenueFileTypeId', {
//       is: 132,
//       then: (schema) =>
//         schema
//           .required('Disbursed Amount is required')
//           .positive('Disbursed Amount must be greater than 0')
//           .max(1000000000, 'Please enter amount less than 10,00,00,000'),
//       otherwise: (schema) => schema.notRequired()
//     }),

//   fileRequestDate: yup.date().when('revenueFileTypeId', {
//     is: 128, // only for request file type
//     then: yup.date().required('Request Date is required')
//   }),

//   fileApprovalDate: yup.date().when('revenueFileTypeId', {
//     is: 130, // only for approved file type
//     then: yup.date().required('Approval Date is required')
//   }),

//   fileDisbursedDate: yup.date().when('revenueFileTypeId', {
//     is: 132, // only for disbursed file type
//     then: yup.date().required('Disburse Date is required')
//   }),

//   loanTypeId: yup
//     .string()
//     .nullable()
//     .required('Loan Product Type is required')
//     .notOneOf(['', ' ', null], 'Please select a valid Loan Product Type'),

//   misMonth: yup
//     .string()
//     .required('MIS Month is required')
//     .matches(/^\d{4}-\d{2}$/, 'Invalid Month format (YYYY-MM)')
// });

function ViewRevenue() {
  const [openSendMsg, setOpenSendMsg] = useState(false);
  const [editFile, setEditFile] = useState(false);
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState('md');
  const [partnerDetail, setPartnerDetail] = useState(false);
  const [viewMorePopup, setViewMorePopup] = useState(false);
  const [openApiError, setOpenApiError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [openLoader, setOpenLoader] = useState(false);
  const [addNewComment, setAddNewComment] = useState('');
  const [completeCommentMessage, setCompleteCommentMessage] = useState('');
  const [selectPartnerName, setSelectPartnerName] = useState(' ');

  const dispatch = useDispatch();
  const location = useLocation();
  const revenueId = location?.state || {};
  const { LoanTypeDrop, BankBranchDrop, BankDrop, MasterTypeListDrop } = useGlobalSelector();
  const { RevenueListViewData, RevenueCommentLog } = useRevenueSelector();
  const { LoginData } = useLoginSelector();

  const {
    handleSubmit: handleReduxSubmit,
    control,
    setValue,
    reset,
    watch,
    formState: { errors }
  } = useForm({
    mode: 'onChange', // Add this to validate on blur
    defaultValues: {
      bankId: '',
      fileNumber: '',
      borrowerName: '',
      branchId: '',
      loanTypeId: '',
      misMonth: ''
    }
  });

  const handleEditOpen = (e) => {
    // reset();
    reset(
      {
        revenueFileTypeId: revenueId?.revenueFileStatusId || ''
      },
      {
        keepDefaultValues: true // ensures other default values are maintained
      }
    );
    setEditFile(true);
    if (RevenueListViewData !== null) {
      const object = {
        value: RevenueListViewData?.bankId
      };
      handleBranchDetails(object);
      // setValue('revenueFileTypeId', revenueId?.revenueFileStatusId);
      setValue('bankId', RevenueListViewData?.bankId || '');
      setValue('branchId', RevenueListViewData?.branchId || '');
      setValue('fileNumber', RevenueListViewData?.fileNumber || '');
      setValue('borrowerName', RevenueListViewData?.borrowerName || '');
      setValue('loanTypeId', RevenueListViewData?.loanTypeId || '');
      setValue('misMonth', RevenueListViewData?.misMonth || '');
      // Conditional amounts
      setValue('loanAmountRequested', RevenueListViewData?.loanAmountRequested || null);
      setValue('loanAmountDisbursed', RevenueListViewData?.loanAmountDisbursed || null);

      // Conditional dates
      setValue('fileRequestDate', fDate2(RevenueListViewData?.fileRequestDate) || null);
      setValue('fileApprovalDate', fDate2(RevenueListViewData?.fileApprovalDate) || null);
      setValue('fileDisbursedDate', fDate2(RevenueListViewData?.fileDisbursedDate) || null);
    }
  };

  const handleEditPartner = async (e) => {
    if (
      RevenueListViewData !== null &&
      RevenueListViewData?.fileNumber &&
      RevenueListViewData?.bankId
    ) {
      const fileNumber = RevenueListViewData?.fileNumber;
      const BankId = RevenueListViewData?.bankId;

      setOpenLoader(true);
      const CheckPartnerExistApi = await CheckPartnerExist(fileNumber, BankId, LoginData?.jwt);
      setOpenLoader(false);
      if (CheckPartnerExistApi.data.isPartnerExist === true) {
        setPartnerDetail(true);
      } else {
        setOpenApiError(true);
        setErrorMessage('File Not Available In Payout');
      }
    }
  };

  const handlePartnerDetatailSubmit = async (e) => {
    if (selectPartnerName === ' ') {
      dispatch(setApiError('Please select partner name'));
      return;
    }

    const cretentials = {
      bankId:
        RevenueListViewData !== null && RevenueListViewData?.bankId
          ? RevenueListViewData?.bankId
          : null,
      fileNumber:
        RevenueListViewData !== null && RevenueListViewData?.fileNumber
          ? RevenueListViewData?.fileNumber
          : null,
      partnerId:
        selectPartnerName !== ' ' && JSON.parse(selectPartnerName)?.partnerId
          ? JSON.parse(selectPartnerName).partnerId
          : null,
      userId: LoginData?.userId
    };
    setOpenLoader(true);
    const EditPartnerDetailApi = await EditPartnerDetail(cretentials, LoginData?.jwt);
    setOpenLoader(false);
    if (EditPartnerDetailApi.status === 'success') {
      setPartnerDetail(false);
      getRevenueViewApi();
    } else {
      setOpenApiError(true);
      setErrorMessage('Something went wrong, unable to submit partner details');
    }
  };

  const handleAddComment = async (e) => {
    if (addNewComment === '') {
      dispatch(setApiError('Please write your comments'));
      return;
    }

    const credentials = {
      comment: addNewComment,
      commentPutBy: LoginData?.userId,
      revenueId: revenueId !== null ? revenueId.revenueId : null
    };
    try {
      const res = await dispatch(saveApiData(RevenueApi?.revenueAddComment, credentials));
      if (res?.status === 'success') {
        getRevenueViewApi();
        setOpenSendMsg(false);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  // loan type & Bank Dropdown
  const getLoanTypeBankDropAPi = useCallback(() => {
    if (!LoginData) return;
    const data = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId
    };
    dispatch(getLoanTypeData(data));
    dispatch(getBankDropdownData(data));
  }, [LoginData]);

  // Master Type List
  const getMasterTypeListApi = () => {
    const type = 'REVENUE_FILE_STATUS_TYPE';
    dispatch(getMasterListType(type));
  };

  const getRevenueViewApi = useCallback(() => {
    const obj = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      leadId: revenueId?.leadId,
      applicationId: revenueId?.applicationId,
      revenueId: revenueId?.revenueId
    };
    if (revenueId?.revenueId) {
      dispatch(getRevenueViewData(obj)); // Revenue view data
      dispatch(getRevenueCommentLogs(revenueId?.revenueId)); // comment logs
    }
  }, [LoginData, revenueId]);

  useEffect(() => {
    getMasterTypeListApi();
    getLoanTypeBankDropAPi(); // 2 api
    dispatch(getRevenuePartnerDetails()); // partner details
  }, []);

  useEffect(() => {
    getRevenueViewApi();
  }, [getRevenueViewApi]);

  const handleBranchDetails = (bankValue) => {
    const myValue = bankValue?.value || bankValue || null;
    if (!myValue) {
      setValue('branchId', null);
      dispatch(setBranchDetails(null));
      return '';
    }
    dispatch(getBankBranchData(myValue));
  };

  const watchFileTypeId = watch('revenueFileTypeId');
  const fileTypeInputs = {
    128: { name: 'fileRequestDate', label: 'Request Date', type: 'date' },
    130: { name: 'customerName', label: 'Approval Date', type: 'date' }, // fixed type from 'fileApprovalDate' to 'date'
    132: { name: 'fileDisbursedDate', label: 'Disburse Date', type: 'date' }
  };
  const inputProps = fileTypeInputs[watchFileTypeId];

  const loanAmountInput = {
    132: { name: 'loanAmountDisbursed', label: 'Disbursed Amount' },
    default: { name: 'loanAmountRequested', label: 'Total Loan Amount' }
  };
  const inputAmount = loanAmountInput[watchFileTypeId] || loanAmountInput.default;

  const onSubmit = useCallback(
    async (data) => {
      const finalData = {
        ...data,
        companyId: LoginData?.companyId,
        userId: LoginData?.userId,

        fileRequestDate: data.fileRequestDate ? `${data.fileRequestDate}T00:00:00` : null,

        fileApprovalDate: data.fileApprovalDate ? `${data.fileApprovalDate}T00:00:00` : null,

        fileDisbursedDate: data.fileDisbursedDate ? `${data.fileDisbursedDate}T00:00:00` : null
      };
      try {
        const res = await dispatch(saveApiData(RevenueApi?.addNewFile, finalData));
        if (res?.status === 'success') {
          getRevenueViewApi();
          setEditFile(false);
        }
      } catch (error) {
        console.error('Error submitting form:', error);
      }
    },
    [LoginData] // 🔹 depends on LoginData
  );

  useEffect(() => {
    if (revenueId) {
      setValue('revenueFileTypeId', revenueId?.revenueFileStatusId);
    }
  }, [revenueId]);

  const revenueFields = useMemo(
    () => [
      {
        label: 'Bank Name',
        value: RevenueListViewData?.bankName,
        icon: <EventNoteIcon className="viewLabelIcon" size={24} />
      },
      {
        label: 'File No',
        value: RevenueListViewData?.fileNumber,
        icon: <EventNoteIcon className="viewLabelIcon" size={24} />
      },
      {
        label: 'Borrower Name',
        value: RevenueListViewData?.borrowerName,
        icon: <EventIcon className="viewLabelIcon" size={24} />
      },
      {
        label: 'Branch Name',
        value: RevenueListViewData?.branchName,
        icon: <CalendarTodayIcon className="viewLabelIcon" size={24} />
      },
      {
        label: 'Employee Class',
        value: RevenueListViewData?.empClass,
        icon: <GroupIcon className="viewLabelIcon" size={24} />
      },
      {
        label:
          revenueId?.revenueFileStatusName === 'Disbursed' ? 'Disbursed Date' : 'Total Loan Amount',
        value:
          revenueId?.revenueFileStatusName === 'Disbursed'
            ? RevenueListViewData?.fileDisbursedDate
              ? fDate(RevenueListViewData?.fileDisbursedDate)
              : null
            : RevenueListViewData?.loanAmountRequested,
        icon: <GroupIcon className="viewLabelIcon" size={24} />
      },
      {
        label:
          revenueId?.revenueFileStatusName === 'Receipt'
            ? 'Request Date'
            : revenueId?.revenueFileStatusName === 'Approved'
            ? 'Approval Date'
            : 'Disbursed Amount',
        value:
          revenueId?.revenueFileStatusName === 'Receipt'
            ? RevenueListViewData?.fileRequestDate
              ? fDate(RevenueListViewData?.fileRequestDate)
              : null
            : revenueId?.revenueFileStatusName === 'Approved'
            ? RevenueListViewData?.fileApprovalDate
              ? fDate(RevenueListViewData?.fileApprovalDate)
              : null
            : RevenueListViewData?.loanAmountDisbursed,
        icon: <MdOutlineDateRange className="viewLabelIcon" size={24} />
      },
      {
        label: 'Loan Product Type',
        value: RevenueListViewData?.loanProductType,
        icon: <MdOutlineDateRange className="viewLabelIcon" size={24} />
      },
      {
        label: 'SM Contact Name',
        value: RevenueListViewData?.smContactName,
        icon: <MdOutlineDateRange className="viewLabelIcon" size={24} />
      },
      {
        label: 'SM Mobile Number',
        value: RevenueListViewData?.smMobNumber,
        icon: <MdOutlineDateRange className="viewLabelIcon" size={24} />
      },
      {
        label: 'SM Email',
        value: RevenueListViewData?.smEmail,
        icon: <MdOutlineDateRange className="viewLabelIcon" size={24} />
      },
      {
        label: 'MIS Month',
        value: RevenueListViewData?.misMonth,
        icon: <MdOutlineDateRange className="viewLabelIcon" size={24} />
      },
      ...(revenueId?.revenueFileStatusName === 'Receipt'
        ? [
            {
              label: 'File Type',
              value: RevenueListViewData?.revenueFileTypeName,
              icon: <MdOutlineDateRange className="viewLabelIcon" size={24} />
            }
          ]
        : [])
    ],
    [RevenueListViewData, revenueId]
  );

  const partnerDetailFields = useMemo(
    () => [
      {
        icon: <GiPayMoney size={24} />,
        label: 'Partner ID',
        value: RevenueListViewData?.partnerId
      },
      {
        icon: <GiTakeMyMoney size={24} />,
        label: 'Partner Name',
        value: RevenueListViewData?.partnerName
      },
      {
        icon: <AdUnitsIcon size={24} />,
        label: 'Partner Type',
        value: RevenueListViewData?.partnerTypeName
      },
      {
        icon: <GroupIcon size={24} />,
        label: 'Partner Commission',
        value: RevenueListViewData?.partnerCommision
      }
    ],
    [RevenueListViewData]
  );

  return (
    <Page title="Partner Management System || Revenue">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="View File" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Box container textAlign="right">
            <Box className="statusBox">
              <Typography variant="body2">MIS Status:</Typography>
              <Typography variant="subtitle2" className="disbursedText">
                {normalizeValue(RevenueListViewData?.misStatus, `${NOT_AVAILABLE}`)}
              </Typography>
            </Box>
          </Box>
          <ViewLargeCard title="File Details" fields={revenueFields} handleEdit={handleEditOpen} />
          <ViewCardComponent
            title="Partner Details"
            // handleEdit={(e) => handleEditPartner(e)}
            fields={partnerDetailFields}
          />
          <Typography variant="body1" className="headingLineUp headingLineUpOut">
            Comments Log
          </Typography>
          <Box className="viewLeadCard cardTopMinusMargin viewCardPadding">
            <Box className="extraTopIcon">
              <Tooltip
                title="Send Message"
                placement="top"
                arrow
                onClick={(e) => {
                  setOpenSendMsg(true);
                }}
              >
                <StyledIconButton className="squareIconButton squareIconButtonFilled">
                  <MdOutlineSendToMobile size={14} />
                </StyledIconButton>
              </Tooltip>
            </Box>
            <Dialog open={openSendMsg} fullWidth>
              <DialogTitle className="popupTitle">
                <Typography variant="h6">Add New Message</Typography>
                <IconButton
                  onClick={(e) => {
                    setOpenSendMsg(false);
                    setAddNewComment('');
                  }}
                  size="small"
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers>
                <Box>
                  <FormControl fullWidth>
                    <TextField
                      variant="outlined"
                      placeholder="Write Your Comments"
                      fullWidth
                      multiline
                      rows={5}
                      value={addNewComment}
                      onChange={(e) => setAddNewComment(e.target.value)}
                    />
                  </FormControl>
                </Box>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={(e) => {
                    handleAddComment(e);
                  }}
                  variant="contained"
                  className="mainBtn"
                >
                  Submit
                </Button>
              </DialogActions>
            </Dialog>
            <TableContainer sx={{ minWidth: 800, overflow: 'auto', background: 'white' }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Date</StyledTableCell>
                    <StyledTableCell align="">Person Name</StyledTableCell>
                    <StyledTableCell align="">Comments</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {RevenueCommentLog?.length > 0 &&
                    RevenueCommentLog?.map((item, index) => {
                      let commentDetailsStr = item.commentDetails;
                      if (commentDetailsStr && commentDetailsStr.length > 20) {
                        commentDetailsStr = commentDetailsStr.substring(0, 20);
                      }
                      return (
                        <StyledTableRow>
                          <StyledTableCell align="">
                            {isValidValue(item.commentLogDate)
                              ? fDate(item.commentLogDate)
                              : `${NOT_AVAILABLE}`}
                          </StyledTableCell>
                          <StyledTableCell align="">
                            {item.personName ? item.personName : `${NOT_AVAILABLE}`}
                          </StyledTableCell>
                          <StyledTableCell align="">
                            {commentDetailsStr ? commentDetailsStr : `${NOT_AVAILABLE}`}
                            <Tooltip title="More" placement="top" arrow>
                              <IconButton
                                size="small"
                                variant="subtitle2"
                                onClick={(e) => {
                                  setViewMorePopup(true);
                                  setCompleteCommentMessage(item.commentDetails);
                                }}
                              >
                                <MdOutlineMoreHoriz size={16} />
                              </IconButton>
                            </Tooltip>
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            <Dialog open={viewMorePopup} onClose={(e) => setViewMorePopup(false)}>
              <DialogContent dividers>
                <Typography variant="body2">{completeCommentMessage}</Typography>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={(e) => setViewMorePopup(false)}
                  variant="contained"
                  className="mainBtn"
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </Box>

        <Dialog
          className="PopupBox"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={editFile}
          PaperProps={{
            sx: {
              overflow: 'visible', // ✅ KEY FIX,
              zIndex: 100000
            }
          }}
        >
          <DialogTitle className="popupTitle">
            <Typography variant="h6">Edit File</Typography>
            <IconButton onClick={(e) => setEditFile(false)} size="small">
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <form id="updateRevenue" onSubmit={handleReduxSubmit(onSubmit)}>
              <Grid container spacing={3} mb={3}>
                <Grid item xs={4}>
                  <CustomSelect
                    name="bankId"
                    label="Bank Name"
                    control={control}
                    errors={errors}
                    options={BankDrop || []}
                    isRequired
                    onChange={(event, val, option, reason, details) => {
                      handleBranchDetails(val);
                    }}
                    fieldCode="NAME"
                    fieldType="ALPHABET"
                  />
                </Grid>
                <Grid item xs={4}>
                  <CustomInput
                    name="fileNumber"
                    label="File No"
                    control={control}
                    errors={errors}
                    isRequired
                    fieldCode="FILE_NO"
                    fieldType="TEXT_FIELD"
                  />
                </Grid>
                <Grid item xs={4}>
                  <CustomInput
                    name="borrowerName"
                    label="Borrower Name"
                    control={control}
                    errors={errors}
                    isRequired
                    fieldCode="NAME"
                    fieldType="ALPHABET"
                  />
                </Grid>
                <Grid item xs={4}>
                  <CustomSelect
                    name="branchId"
                    label="Branch Name"
                    control={control}
                    errors={errors}
                    options={BankBranchDrop || []}
                    isRequired
                    fieldCode="NAME"
                    fieldType="ALPHABET"
                  />
                </Grid>
                {/* {false && (
                  <Grid item xs={4}>
                    <CustomSelect
                      name="revenueFileTypeId"
                      label="File Type"
                      disabled
                      control={control}
                      errors={errors}
                      options={MasterTypeListDrop || []}
                      isRequired
                    />
                  </Grid>
                )} */}
                <Grid item xs={4}>
                  <CustomInput
                    name={inputAmount?.name}
                    label={inputAmount?.label}
                    control={control}
                    errors={errors}
                    isRequired
                    fieldCode="AMOUNT"
                    fieldType="AMOUNT_FIELD" // Numbers with decimals and commas
                    type="text"
                  />
                </Grid>
                {inputProps && (
                  <Grid item xs={4}>
                    {/* <CustomInput
                      name={inputProps.name}
                      type={inputProps.type}
                      label={inputProps.label}
                      control={control}
                      errors={errors}
                      isRequired
                      fieldCode="DATE"
                      fieldType="DATE_FIELD"
                    /> */}
                    <CustomDate
                      name={inputProps.name}
                      label={inputProps.label}
                      control={control}
                      errors={errors}
                      isRequired
                      fieldCode="DATE"
                      fieldType="DATE_FIELD"
                    />
                  </Grid>
                )}
                <Grid item xs={4}>
                  <CustomSelect
                    name="loanTypeId"
                    label="Loan Product Type"
                    control={control}
                    errors={errors}
                    options={LoanTypeDrop || []}
                    isRequired
                  />
                </Grid>
                <Grid item xs={4}>
                  <CustomInput
                    name="misMonth"
                    label="MIS Month"
                    type="month"
                    control={control}
                    errors={errors}
                    isRequired
                    fieldCode="MONTH"
                    fieldType="DATE_FIELD"
                  />
                </Grid>
              </Grid>{' '}
            </form>{' '}
          </DialogContent>
          <DialogActions>
            <Button type="submit" form="updateRevenue" variant="contained" className="mainBtn">
              Submit
            </Button>
          </DialogActions>
        </Dialog>

        <Loader openLoader={openLoader} />
        <ApiErrorMessage
          openApiError={openApiError}
          setOpenApiError={setOpenApiError}
          errorMessage={errorMessage}
        />
      </Container>
    </Page>
  );
}
export default ViewRevenue;
